import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
    isLoading: false,
    error: null,
    reports: [],
    report: null,
};

const slice = createSlice({
    name: 'reports',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        setReportsSuccess(state, action) {
            state.isLoading = false;
            state.reports = action.payload;
        },
        setReportSuccess(state, action) {
            state.isLoading = false;
            state.report = action.payload;
        },
        setReport(state, action) {
            state.report = action.payload;
        },
        deleteReportSuccess(state, action) {
            state.isLoading = false;
            state.reports = state.reports.filter((r) => r.id !== action.payload);
        },
    },
});

export default slice.reducer;

// Actions
export const { setReport } = slice.actions;

export function getReports(shopid) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            // shop_id is mandatory in the URL per user requirement
            const response = await axios.get(`/reports/${shopid}/list`);
            if (response.data.success) {
                dispatch(slice.actions.setReportsSuccess(response.data.data));
            } else {
                throw new Error(response.data.message);
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getReport(shopid, id) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(`/reports/${shopid}/detail/${id}`);
            if (response.data.success) {
                dispatch(slice.actions.setReportSuccess(response.data.data));
            } else {
                throw new Error(response.data.message);
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function saveReport(shopid, data) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.post(`/reports/${shopid}/save`, data);
            if (response.data.success) {
                return response.data.id;
            } else {
                throw new Error(response.data.message);
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            throw error;
        }
    };
}

export function deleteReport(shopid, id) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.delete(`/reports/${shopid}/${id}`);
            if (response.data.success) {
                dispatch(slice.actions.deleteReportSuccess(id));
            } else {
                throw new Error(response.data.message);
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
